// A video re-encoded with one track drawn into it.

import { api } from '../client'
import type { components } from '../schema'

export type StartSubtitleBurnRequest = components['schemas']['StartSubtitleBurnRequest']
export type SubtitleBurnView = components['schemas']['SubtitleBurnView']
export type SubtitleBurnCodec = components['schemas']['SubtitleBurnCodec']

function burnsPath(subtitleId: string): string {
  return `/subtitles/${encodeURIComponent(subtitleId)}/burns`
}

/**
 * Queue a burn of this track, and answer the burn as its poll will. Once `processing_status` is
 * `completed`, `asset_file_id` is what `createDownload` takes. 422 when the asset is not a video,
 * or the track holds no cue; 429 when the organization's media queue is full.
 */
export function createSubtitleBurn(subtitleId: string, request: StartSubtitleBurnRequest): Promise<SubtitleBurnView> {
  return api.post<SubtitleBurnView>(burnsPath(subtitleId), request)
}

/** One burn, by its own uid: poll until `completed` or `failed`; `cancelled` is a retired asset. */
export function getSubtitleBurn(subtitleId: string, burnId: string, signal?: AbortSignal): Promise<SubtitleBurnView> {
  return api.get<SubtitleBurnView>(`${burnsPath(subtitleId)}/${encodeURIComponent(burnId)}`, undefined, signal)
}

/** The burns of a track, newest first. */
export function listSubtitleBurns(subtitleId: string, signal?: AbortSignal): Promise<SubtitleBurnView[]> {
  return api.get<SubtitleBurnView[]>(burnsPath(subtitleId), undefined, signal)
}
